import { render, staticRenderFns } from "./paymentSucceeded.vue?vue&type=template&id=18931234&scoped=true"
import script from "./paymentSucceeded.vue?vue&type=script&lang=js"
export * from "./paymentSucceeded.vue?vue&type=script&lang=js"
import style0 from "./paymentSucceeded.vue?vue&type=style&index=0&id=18931234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18931234",
  null
  
)

export default component.exports